import _ from 'lodash'
const xss = require('xss')

let utils = {
  isIphone: () => /iphone|ipad|ipod/i.test(navigator.userAgent),
  isAndroid: () => /Android/i.test(navigator.userAgent),
  isPhoneNumber: (v) => {
    return /^(\+?86)?[1][3,4,5,7,8,9][0-9]{9}$/.test(v)
  },
  isTelNumber: (v) => {
    return /^0\d{2,3}-?\d{7,8}$/.test(v)
  },
  isWeixn () {
    let ua = navigator.userAgent.toLowerCase()
    return ua.match(/MicroMessenger/i) === 'micromessenger'
  },
  getRandomStr (len) {
    len = len || 32
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let maxPos = chars.length
    let str = ''
    for (let i = 0; i < len; i++) {
      str += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return str
  },
  getSuffix (filename) {
    let pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos !== -1) suffix = filename.substring(pos)
    return suffix.toLocaleLowerCase()
  },
  toThousands (num, len) {
    len = len || 0
    var negative = false
    if (num < 0) negative = true
    num = Math.abs(num)
    num = _.round(parseFloat(num) || 0, len).toString()
    let dot = num.replace(/^\d+?\./, '.')
    let result = ''
    if (num === dot) {
      dot = ''
    } else {
      num = num.replace(dot, '')
    }
    while (num.length > 3) {
      result = ',' + num.slice(-3) + result
      num = num.slice(0, num.length - 3)
    }
    if (num) result = num + result
    if (negative) {
      return '-' + result + dot
    } else {
      return result + dot
    }
  },
  padZeroPlaces (num, n) {
    num += ''
    n = n || 2
    let decimal = num.split('.')
    let decimalLen = n - (decimal.length === 1 ? 0 : decimal[1].length)
    if (decimalLen <= 0) {
      return num
    } else {
      return num + (decimal.length === 1 ? '.' : '') + (new Array(1 + decimalLen)).join('0')
    }
  },
  scrollTo (el, from = 0, to, duration = 500, endCallback) {
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = (
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 1000 / 60)
        }
      )
    }
    const difference = Math.abs(from - to)
    const step = Math.ceil(difference / duration * 50)

    function scroll (start, end, step) {
      if (start === end) {
        endCallback && endCallback()
        return
      }

      let d = (start + step > end) ? end : start + step
      if (start > end) {
        d = (start - step < end) ? end : start - step
      }

      if (el === window) {
        window.scrollTo(d, d)
      } else {
        el.scrollTop = d
      }
      window.requestAnimationFrame(() => scroll(d, end, step))
    }
    scroll(from, to, step)
  },
  scrollTop (duration = 150) {
    const sTop = document.documentElement.scrollTop || document.body.scrollTop
    this.scrollTo(window, sTop, 0, duration)
  },
  removeXSS (str, tripTag = false) {
    str = _.trim(str)
    if (_.isEmpty(str)) return ''
    let whiteList = []
    if (!tripTag) {
      whiteList = _.merge(xss.whiteList, {
        div: [], p: [], span: [], img: ['src']
      })
    }
    return xss(str, {
      whiteList: whiteList,
      stripIgnoreTag: true,
      stripIgnoreTagBody: ['script']
    }).replace(/\[removed\]/, '')
  },
  getAfterMonths (val, ms) {
    var d = val ? new Date(val) : new Date()
    d.setMonth(d.getMonth() + ms)
    return d.getTime()
  },
  removeTag (str) {
    return _.trim(str.replace(/<[^>]+>.+?<\/[^>]+>/g, ''))
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/assets/js/helper/utils.js